import styles from "../Cadastro.module.css";
import { FormControl, InputLabel, Tooltip } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import { HelperText } from "../../../../components/Errors/HelperText";
import { SolicAcessoSearchField } from "../../../../components/Searchfields/SolicitacaoAcesso";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook, faBoxOpen, faFileWord, faPenRuler } from "@fortawesome/free-solid-svg-icons";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBR from "date-fns/locale/pt-BR";

const EtapaConcluida = ({ nome, situacao, situacaoParecer, situacaoSolicAcesso }) => {
    return (
        <Tooltip placement="top-end" title={
            situacao === 1 
            ? `Análise não avaliada`
            : situacao === 2 && situacaoParecer !== 1 && situacaoSolicAcesso !== 1
            ? `Análise aprovada`
            : situacao === 3 && situacaoParecer !== 1 && situacaoSolicAcesso !== 1
            ? `Análise aprovada com ressalvas`
            : situacao === 4 && situacaoParecer !== 1 && situacaoSolicAcesso !== 1
            ? `Análise reprovada`
            : `Análise não avaliada`
        } >
            <div className={
                situacao === 1
                ? ` ${styles.situacaoEtapa} ${styles.naoAvaliado}`
                : situacao === 2 && situacaoParecer !== 1 && situacaoSolicAcesso !== 1
                ? ` ${styles.situacaoEtapa} ${styles.aprovada}`
                : situacao === 3 && situacaoParecer !== 1 && situacaoSolicAcesso !== 1
                ? ` ${styles.situacaoEtapa} ${styles.favoravelRessalva}`
                : situacao === 4 && situacaoParecer !== 1 && situacaoSolicAcesso !== 1
                ?` ${styles.situacaoEtapa} ${styles.reprovado}`
                :` ${styles.situacaoEtapa} ${styles.naoAvaliado}`
            }>
                <FontAwesomeIcon icon={
                    nome === 'Projeto' 
                    ? faFileWord 
                    : nome === 'Equipamentos'
                    ? faBoxOpen
                    : nome === 'Viabilidade técnica'
                    ? faPenRuler
                    : faBook
                } />
                {nome}
            </div>
        </Tooltip>
    )
}

const Geral = ({ aprovado, situacao, analise, uc }) => {
    const { control, getValues, formState: { errors } } = useFormContext();

    const editavel = getValues("Id") === 0 ? true : false;

    return (
        <div>
            <div className={styles['input-container']}>
                <Controller 
                    name="SolicitacaoDeAcesso"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-g']} style={{ zIndex: 2}}>
                            <InputLabel htmlFor="vistoria-solic-acesso" shrink sx={{ color: "#B8B8B8" }}>Orçamento de conexão</InputLabel>
                            <SolicAcessoSearchField 
                                id="vistoria-solic-acesso" 
                                field={field} 
                                disabled={editavel} 
                                className={`${errors?.SolicitacaoDeAcesso ? styles.campoComValorErrado : ""}`} 
                            />
                            { errors?.SolicitacaoDeAcesso && (
                                <HelperText text="Este campo é obrigatório" />
                            )}
                        </FormControl>
                    )}
                />
            </div>

            <div className={styles.etapaSituacoes}>
                <EtapaConcluida nome="Documentos" situacao={analise ? analise.ParecerDocumentos : 1} situacaoParecer={analise?.Situacao} situacaoSolicAcesso={analise?.SolicitacaoDeAcesso?.Situacao} />
                <EtapaConcluida nome="Equipamentos" situacao={analise ? analise.ParecerEquipamento : 1} situacaoParecer={analise?.Situacao} situacaoSolicAcesso={analise?.SolicitacaoDeAcesso?.Situacao} />
                <EtapaConcluida nome="Projeto" situacao={analise ? analise.ParecerProjeto : 1} situacaoParecer={analise?.Situacao} situacaoSolicAcesso={analise?.SolicitacaoDeAcesso?.Situacao} />
                <EtapaConcluida nome="Viabilidade técnica" situacao={analise ? analise.ParecerViabTecnica : 1} situacaoParecer={analise?.Situacao} situacaoSolicAcesso={analise?.SolicitacaoDeAcesso?.Situacao} />
            </div>

            <div className={styles.inputContainerColumn}>
                <FormControl variant="outlined" style={{ marginTop: "5px", marginLeft: "60px" }} className={styles['campos-p']}>
                    <InputLabel shrink style={{ color: "#B8B8B8" }} >
                        Data conclusão da instalação de GD
                    </InputLabel>
                    <Controller 
                        name="DataConclusaoInstalacaoGD"
                        control={control}
                        render={({ field }) => (
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                                <DatePicker 
                                    fullWidth
                                    inputFormat="dd/MM/yyyy"
                                    {...field}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <>
                                            <WhiteInput ref={inputRef}  {...inputProps} sx={{color: "#fff"}} className={`${errors?.DataConclusaoInstalacaoGD ? styles.campoComValorErrado : ""}`}  />
                                            <span style={{ position: "absolute", top: 38, right: 15, color: "white", svg: "white", input: "white", label: "white" }}>
                                                {InputProps?.endAdornment}
                                            </span>
                                        </>
                                    )}
                                />
                            </LocalizationProvider>
                        )}
                    />
                    { errors?.DataConclusaoInstalacaoGD && (
                        <HelperText text={errors?.DataConclusaoInstalacaoGD?.message} />
                    )}
                </FormControl>
                <Controller 
                    name="Observacao"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" style={{ marginTop: "20px", marginLeft: "60px" }} className={styles['campos-g']}>
                            <InputLabel htmlFor="vistoria-observacoes" shrink sx={{ color: "#B8B8B8" }}>Observações</InputLabel>
                            <WhiteInput 
                                fullWidth
                                placeholder="Observações"
                                id="vistoria-observacoes"
                                name="Observacao"
                                minRows={6}
                                maxRows={6}
                                multiline
                                {...field}
                                className={`${errors?.Observacao ? styles.campoComValorErradoTextArea : ""}`} 
                            />
                            { errors?.Observacao && (
                                <HelperText text={errors?.Observacao?.message} />
                            )}
                        </FormControl>
                    )}
                />
            </div> 
        </div>
    )
}

export { Geral }